import styled from 'styled-components'
import { breakpoints } from '../../MediasQueries'

export const InputDiv = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  padding: 10px 2vh;
`

export const ItemInput = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-columns: ${(props) => props.grid};
  @media (max-width: ${breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
  padding: 2vh 0px;
`
export const Label = styled.label`
  align-self: center;
  font-weight: bold;
`
export const ButtonDiv = styled.div``
export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.7fr;
  column-gap: 30px;
  @media (max-width: ${breakpoints.sm}) {
    grid-template-columns: 1fr;
  }

  label {
    margin-right: 15px;
  }
`
export const Plataforms = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`
